<div class="w-full bg-white border-box radius-10" id="information-verif"
  [style.border]="isValidated ? '2px solid #28a745' : 'none'">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Etablissement dans lequel s'est déroulé l'élection</p>
            <p class="no-margin dark-gray text-sm">Toutes les informations de cette section sont obligatoires</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>


  <div *ngIf="isExpanded" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid"
    class="p-20">
    <div>
      <p class="dark-gray no-margin">Raison sociale</p>
      <p class="dark-blue bold">{{venue.legalName}}</p>
      <!-- <input [(ngModel)]="venue.legalName" (ngModelChange)="onVenueChange()" type="text" name="raison_sociale"
        id="raison_sociale" class="w-full text-md dark-blue pap-input" value="{{venue.legalName}}"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Numéro de convention collective (IDCC)</p>
      <p class="dark-blue bold">{{venue.idcc}}</p>
      <!-- <input [(ngModel)]="venue.idcc" (ngModelChange)="onVenueChange()" type="text" name="forme_juridique"
        id="forme_juridique" class="w-full text-md dark-blue pap-input" value="{{venue.idcc}}"
        (keypress)="onlyNumbers($event)" pattern="[0-9]*" inputmode="numeric" maxlength="4"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">SIRET</p>
      <p class="dark-blue bold">{{venue.siret}}</p>
      <!-- <input [(ngModel)]="venue.siret" (ngModelChange)="onVenueChange()" (keypress)="onlyNumbers($event)" type="text"
        name="siret" id="siret" maxlength="14" pattern="[0-9]*" inputmode="numeric"
        class="w-full text-md dark-blue pap-input" value="{{venue.siret}}"> -->
    </div>

    <div></div>

    <div style="grid-column: 1 / -1;">
      <p class="dark-gray no-margin">Adresse</p>
      <p class="dark-blue bold">{{venue.address}}</p>
      <!-- <input [(ngModel)]="venue.address" (ngModelChange)="onVenueChange()" type="text" name="address" id="address"
        class="w-full text-md dark-blue pap-input" value="{{venue.address}}"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Code Postal</p>
      <p class="dark-blue bold">{{venue.zipcode}}</p>
      <!-- <input [(ngModel)]="venue.zipcode" (ngModelChange)="onVenueChange()" type="text" name="postal_code" id="zip"
        class="w-full text-md dark-blue pap-input" value="{{venue.zipcode}}" maxlength="11"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Ville / Commune</p>
      <p class="dark-blue bold">{{venue.city}}</p>
      <!-- <input [(ngModel)]="venue.city" (ngModelChange)="onVenueChange()" type="text" name="city" id="city"
        class="w-full text-md dark-blue pap-input" value="{{venue.city}}"> -->
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>